var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","disabled":_vm.beginning || _vm.loading,"size":"small","loading":_vm.loading},on:{"click":_vm.getVerifyCode}},[_vm._v("\n        "+_vm._s(_vm.beginning ? _vm.time + "s后重新获取" : "获取验证码")+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }